import React from "react";
import { FeatureModule } from "@/shared/types/routing";
import { MyAccountIcon } from "@/shared/ui/icons";

const MyAccount = React.lazy(() => import("./MyAccount"));

const MyAccountModule: FeatureModule = {
    name: "my-account",
    routes: [
        {
            path: "/my-account",
            element: <MyAccount />,
            meta: {
                label: "layout.sidebar.myAccount",
                icon: MyAccountIcon,
                showInSidebar: true,
                requiresAuth: true,
            },
        },
    ],
};

export default MyAccountModule;
